/**
 * <coating-banner>
 *
 * Initialises a Swiper-based slider inside the collection product grid.
 * Slides include image + title pairs; one slide visible at a time with
 * line-segment pagination and autoplay.
 *
 * swiper-bundle.min.js is loaded globally via theme.liquid, so
 * window.Swiper is guaranteed to be available when this script runs
 * (both use defer).
 *
 * Re-initialises on collection facet/pagination updates because
 * morphSection patches the DOM in-place without triggering
 * connectedCallback / disconnectedCallback on the custom element.
 */
class CoatingBanner extends HTMLElement {
  /** @type {import('swiper').Swiper | null} */
  #swiper = null;

  connectedCallback() {
    requestAnimationFrame(() => this.#init());
  }

  disconnectedCallback() {
    this.#swiper?.destroy(true, true);
    this.#swiper = null;
  }

  #init() {
    const swiperEl = this.querySelector('.coating-banner__swiper');
    const paginationEl = this.querySelector('.coating-banner__dots');
    const prevEl = this.querySelector('.coating-banner__arrow--prev');
    const nextEl = this.querySelector('.coating-banner__arrow--next');
    if (!swiperEl || !window.Swiper) return;

    this.#swiper = new window.Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      observer: true,
      observeParents: true,
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      navigation: {
        prevEl,
        nextEl,
      },
    });
  }
}

if (!customElements.get('coating-banner')) {
  customElements.define('coating-banner', CoatingBanner);
}
